import React from 'react';
import { useForm } from 'react-hook-form'; // إذا كنت تستخدمه، أو form عادي
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';

const AddSubCategoryModal = ({ isOpen, onClose, onSubmit, parentCategory }) => {
  const { t } = useTranslation();
  const { register, handleSubmit, formState: { errors }, reset ,watch } = useForm();

  if (!isOpen) return null;
  // Validation للصورة (اختياري: اجعلها إلزامية إذا أردت)
  const imageValidation = {
    validate: (fileList) => {
      if (!fileList || fileList.length === 0) {
        return t("imageRequired"); // "الصورة مطلوبة"
      }
      const file = fileList[0];
      if (file && !file.type.startsWith('image/')) {
        return t("invalidImageType"); // "نوع الملف غير مدعوم، اختر صورة"
      }
      if (file && file.size > 5 * 1024 * 1024) { // 5MB max
        return t("imageTooLarge"); // "حجم الصورة كبير جداً"
      }
      return true;
    }
  };

  const onFormSubmit = (data) => {
    onSubmit(data); // يرسل البيانات إلى الـ parent
   // reset(); // أعد تعيين الـ form
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium">
            {t("addSubCategory")} - {parentCategory?.translations?.ar?.name}
          </h3>
          <Button variant="ghost" onClick={onClose} size="icon">
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* عرض الـ Parent Category */}
        {parentCategory && (
          <div className="mb-4 p-3 bg-muted rounded-md">
            <p className="text-sm text-muted-foreground">
              {t("الفئة الأساسية")}: {parentCategory.translations?.ar?.name}
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit(onFormSubmit)}>
          {/* حقول الـ Form - نفسها مثل إضافة category عادية */}
          <div className="space-y-4">
            {/* مثال: حقل الاسم (Arabic) */}
            <div>
              <label className="block text-sm font-medium mb-1">
                {t("arabicSubCategoryName")}
              </label>
              <input
                {...register('translations.ar.name', { required: true })}
                className="w-full p-2 border border-border rounded-md"
                placeholder={t("arNameError")}
              />
              {errors.translations?.ar?.name && (
                <p className="text-sm text-destructive mt-1">Required</p>
              )}
            </div>


             {/* حقل الصورة مع validation */}
            <div>
              <label className="block text-sm font-medium mb-1">
                {t("categoryImage")} 
              </label>
              <input
                type="file"
                {...register('image', imageValidation)} // أضف الـ validation هنا
                className="w-full p-2 border border-border rounded-md file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-primary file:text-primary-foreground hover:file:bg-primary/90"
                accept="image/*"
              />
              {errors.image && (
                <p className="text-sm text-destructive mt-1">{errors.image.message}</p>
              )}
              {/* عرض preview للصورة المختارة (اختياري) */}
              {watch('image') && watch('image').length > 0 && (
                <div className="mt-2">
                  <img
                    src={URL.createObjectURL(watch('image')[0])}
                    alt="Preview"
                    className="w-20 h-20 object-cover rounded-md"
                  />
                </div>
              )}
            </div>

            {/* حقل order (اختياري) */}
            <div>
              <label className="block text-sm font-medium mb-1">
                {t("order")}
              </label>
              <input
                type="number"
                {...register('order', { valueAsNumber: true, min: 0 })}
                className="w-full p-2 border border-border rounded-md"
          //      placeholder={t("enterOrder")}
              />
            </div>

      

            {/* حقل مخفي للـ parent (لا يظهر للمستخدم) */}
            <input
              type="hidden"
              value={parentCategory?.id || ''}
              {...register('parent_id')}
            />
          </div>

          <div className="flex justify-end space-x-2 mt-6 gap-2">
            <Button type="button" variant="outline" onClick={onClose}>
              {t("cancel")}
            </Button>
            <Button type="submit">
              {t("addSubCategory")}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSubCategoryModal;
